import Card from "@/components/pages/contact/card";
import ContactUs from "@/components/pages/contact/contact-form";
import Section from "@/components/ui/section";
import Image from "next/image";
import React from "react";
import { m } from "framer-motion";
import { fadeIn } from "@/utils/motion/fade-in";
import Seo from "@/utils/seo";

export default function ContactUsPage() {
  const seo = {
    slug: "contact-us",
    metaTitle: "Contact Chalk Studio | Interior Design Experts",
    metaDescription:
      "Get in touch with Chalk Studio. Reach out for interior design consultations, project inquiries, or general information—we’re here to help!",
  };
  return (
    <>
      <Seo seo={seo} />
      <m.div initial="from" whileInView={"to"} viewport={{ once: true }} variants={fadeIn()}>
        <div className="flex flex-col lg:flex-row w-full ">
          <div className="w-full lg:w-[290px] md:h-[450px] h-[400px] lg:h-screen shrink-0 lg:sticky lg:top-0 relative">
            <Image src={"/images/contact-banner.webp"} priority alt={"contact banner"} fill className="object-cover lg:object-center object-[50%_60%]" quality={35} sizes="(max-width: 479px) 400px,(max-width: 767px) 400px,(max-width: 991px) 400px, 400px"/>
            <div className="absolute top-0 left-0 w-full h-full bg-black/10" />
          </div>
          <Section>
            <Card />
            <ContactUs />
          </Section>
        </div>
      </m.div>
    </>
  );
}
